import { useQuery } from "@tanstack/react-query";

import { tripsApi } from "api";
import { transformToTripClass, Trip } from "models/Trip";

const fetchTrip = async (tripUuid: string) => {
  const [error, response] = await tripsApi.fetchTrip(tripUuid);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useTripData = (tripUuid: string) => {
  return useQuery({
    queryKey: ["trip", tripUuid],
    queryFn: () => fetchTrip(tripUuid),
    select: (data) => transformToTripClass(data.trip) as Trip,
  });
};

export default useTripData;
